<template>
    <div class="card-body2">
        <div class="list-containerbox">
            <!--Shipping-->

            <div class="shiping-details">
                <h5 class="card-title flex-grow-1">Ship To</h5>
                <div class="listDetails">
                    <div v-if="isEditMode" class="row">
                        <div class="col-sm-12 col-md-12">
                            <div class="radiogroups">
                                <div class="form-check-inline">Stocking?</div>
                                <div class="form-check-inline">
                                    <label class="form-check-label">
                                        <input
                                            type="radio"
                                            class="form-check-input"
                                            name="is_stocking"
                                            value="1"
                                            v-model="shippingForm.is_stocking"
                                        />
                                        Yes
                                    </label>
                                </div>
                                <div class="form-check-inline">
                                    <label class="form-check-label">
                                        <input
                                            type="radio"
                                            class="form-check-input"
                                            name="is_stocking"
                                            value="0"
                                            v-model="shippingForm.is_stocking"
                                        />
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-sm-12 col-md-12"
                            v-if="shippingForm.is_stocking == 1"
                        >
                            <div class="form-group">
                                <label>Stocking Terms</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder=""
                                    v-model="shippingForm.stocking_terms"
                                />
                            </div>
                        </div>
                        <div
                            class="col-sm-12 col-md-12"
                            v-if="shippingForm.is_stocking == 1"
                        >
                            <div
                                class="form-group"
                                v-for="(
                                    warehouse, index
                                ) in shippingForm.warehouses"
                            >
                                <!-- {{ shippingForm.warehouses }} -->
                                <div class="selectship">
                                    <label>Superb Warehouse</label>
                                    <div class="selectship-row">
                                        <select
                                            name="cars"
                                            class="custom-select"
                                            v-model="
                                                shippingForm.warehouses[index]
                                                    .warehouse_id
                                            "
                                        >
                                            <option
                                                v-for="item in warehouses"
                                                :value="item.id"
                                            >
                                                {{ item.address }}
                                            </option>
                                        </select>
                                        <a
                                            href="javascript:void(0);"
                                            @click="
                                                removeWarehouse(
                                                    warehouse,
                                                    index
                                                )
                                            "
                                            v-if="
                                                shippingForm.warehouses.length >
                                                1
                                            "
                                            class="btn btn-danger px-3 py-2"
                                            >Remove</a
                                        >
                                    </div>
                                </div>
                                <textarea
                                    class="form-control"
                                    placeholder=""
                                    v-model="
                                        shippingForm.warehouses[index].address
                                    "
                                ></textarea>
                            </div>
                            <div
                                class="addshipbtn"
                                v-if="
                                    shippingForm.warehouses.length <
                                    maxNumOfShipToAddress
                                "
                            >
                                <a
                                    @click="addWarehouse()"
                                    href="javascript:void(0);"
                                    class="btn btn-primary px-3 py-2"
                                    >Add</a
                                >
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12">
                            <div
                                class="form-group"
                                v-for="(
                                    warehouse, index
                                ) in shippingForm.customerWarehouses"
                            >
                                <div class="selectship">
                                    <label
                                        >Customer Warehouse</label
                                    >
                                    <div class="selectship-row">
                                        <select
                                            name="cars"
                                            class="custom-select"
                                            v-model="
                                                shippingForm.customerWarehouses[
                                                    index
                                                ].warehouse_id
                                            "
                                        >
                                            <!-- <option
                                                v-for="item in warehouse"
                                                :value="item.id"
                                            >
                                                {{ item.address }}
                                            </option> -->

                                            <option :value="warehouse.id">
                                                {{
                                                    warehouse.warehouse
                                                        ? warehouse.warehouse
                                                              .address
                                                        : ""
                                                }}
                                            </option>
                                        </select>

                                        <a
                                            href="javascript:void(0);"
                                            @click="
                                                removeCustomerWarehouse(
                                                    warehouse,
                                                    index
                                                )
                                            "
                                            v-if="
                                                shippingForm.customerWarehouses
                                                    .length > 1
                                            "
                                            class="btn btn-danger px-3 py-2"
                                            >Remove</a
                                        >
                                    </div>
                                </div>
                                <textarea
                                    class="form-control"
                                    placeholder=""
                                    v-model="
                                        shippingForm.customerWarehouses[index]
                                            .address
                                    "
                                ></textarea>
                            </div>
                            <div
                                class="addshipbtn"
                                v-if="
                                    shippingForm.customerWarehouses.length <
                                    maxNumOfShipToAddress
                                "
                            >
                                <a
                                    @click="addCustomerWarehouse()"
                                    href="javascript:void(0);"
                                    class="btn btn-primary px-3 py-2"
                                    >Add</a
                                >
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-12">
                            <div
                                class="form-group"
                                v-for="(
                                    warehouse, index
                                ) in shippingForm.billTo"
                            >
                                <div class="selectship">
                                    <label>Bill To</label>
                                    <div class="selectship-row">
                                        <select
                                            name="cars"
                                            class="custom-select"
                                            v-model="
                                                shippingForm.billTo[index]
                                                    .warehouse_id
                                            "
                                        >
                                            <option
                                                v-for="item in customerWarehouses"
                                                :value="item.id"
                                            >
                                                {{ item.address }}
                                            </option>
                                        </select>

                                        <a
                                            href="javascript:void(0);"
                                            @click="
                                                removeBillTo(warehouse, index)
                                            "
                                            v-if="
                                                shippingForm.billTo.length > 1
                                            "
                                            class="btn btn-danger px-3 py-2"
                                            >Remove</a
                                        >
                                    </div>
                                </div>
                                <textarea
                                    class="form-control"
                                    placeholder=""
                                    v-model="shippingForm.billTo[index].address"
                                ></textarea>
                            </div>
                            <div
                                class="addshipbtn"
                                v-if="
                                    shippingForm.billTo.length <
                                    maxNumOfShipToAddress
                                "
                            >
                                <a
                                    @click="addBillTo()"
                                    href="javascript:void(0);"
                                    class="btn btn-primary px-3 py-2"
                                    >Add</a
                                >
                            </div>
                        </div>
                    </div>

                    <div class="address-list">
                        <div v-if="!isEditMode && order.is_stocking">
                            <template v-if="order.warehouses">
                                <ul v-for="(item, index) in order.warehouses">
                                    <li v-if="index > 0"><hr /></li>
                                    <template v-if="item.warehouse">
                                        <li>{{ item.warehouse.address2 }}</li>
                                        <li>{{ item.warehouse.address }}</li>
                                        <li>{{ item.warehouse.state }}</li>
                                        <li>{{ item.warehouse.city }}</li>
                                        <li>{{ item.warehouse.post_code }}</li>
                                    </template>
                                    <template v-else>
                                        <li>{{ item.address }}</li>
                                    </template>
                                </ul>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <template
                v-if="
                    order.customer_warehouses &&
                    order.customer_warehouses.length &&
                    !isEditMode
                "
            >
                <div class="shiping-details">
                    <!--<hr v-if="order.is_stocking">-->
                    <h5 v-if="order.is_stocking" class="card-title flex-grow-1">
                        Customer Delivery Address
                    </h5>
                    <div class="listDetails">
                        <div class="address-list">
                            <ul
                                v-for="(
                                    item, index
                                ) in order.customer_warehouses"
                            >
                                <li v-if="index > 0"><hr /></li>
                                <template v-if="item.warehouse">
                                    <li>{{ item.warehouse.address2 }}</li>
                                    <li>{{ item.warehouse.address }}</li>
                                    <li>{{ item.warehouse.state }}</li>
                                    <li>{{ item.warehouse.city }}</li>
                                    <li>{{ item.warehouse.post_code }}</li>
                                </template>
                                <template v-else>
                                    <li>{{ item.address }}</li>
                                </template>
                            </ul>
                        </div>
                    </div>
                </div>
            </template>

            <template
                v-if="
                    order.bill_warehouses &&
                    order.bill_warehouses.length &&
                    !isEditMode
                "
            >
                <div class="shiping-details">
                    <!--<hr v-if="order.is_stocking">-->
                    <h5 class="card-title flex-grow-1">Bill To</h5>
                    <div class="listDetails">
                        <div class="address-list">
                            <ul v-for="(item, index) in order.bill_warehouses">
                                <li v-if="index > 0"><hr /></li>
                                <template v-if="item.warehouse">
                                    <li>{{ item.warehouse.address2 }}</li>
                                    <li>{{ item.warehouse.address }}</li>
                                    <li>{{ item.warehouse.state }}</li>
                                    <li>{{ item.warehouse.city }}</li>
                                    <li>{{ item.warehouse.post_code }}</li>
                                </template>
                                <template v-else>
                                    <li>{{ item.address }}</li>
                                </template>
                            </ul>
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="!isEditMode && order.is_stocking">
                <div class="stocking-list">
                    <h5 class="card-title flex-grow-1">Stocking Terms</h5>
                    <div class="listDetails">
                        <ul>
                            <li>{{ order.stocking_terms }}</li>
                        </ul>
                    </div>
                </div>
            </template>
            <div class="order-btnsec">
                <a
                    href="javascript:void(0);"
                    v-if="isEditMode"
                    :disabled="loading"
                    @click="saveShippingData"
                    class="btn btn-primary"
                    >Save</a
                >
                <button
                    v-if="isEditMode"
                    style="display: none"
                    type="button"
                    :disabled="loading"
                    class="btn btn-danger ml-1"
                    @click="isEditMode = false"
                >
                    Cancel
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapState } from "vuex";
import Vue from "vue";

export default {
    name: "OrderShipping",
    props: ["order", "loading", "isEditMode"],
    mounted() {
        this.syncLatestData();
    },
    data() {
        return {
            shipSearch: null,
            shippingForm: {
                is_stocking: 0,
                stocking_terms: null,
                warehouses: [],
                customerWarehouses: [],
                billTo: [],
            },
            warehouses: [],
            customerWarehouses: [],
        };
    },
    methods: {
        ...mapActions([
            "setCommonErrors",
            "setErrorMessage",
            "setSuccessMessage",
            "setLoading",
        ]),
        addWarehouse() {
            this.shippingForm.warehouses.push({
                id: null,
                warehouse_id: null,
                address: null,
            });
        },
        removeWarehouse(warehouse, index) {
            if (warehouse.id) {
                this.deleteWarehouse(warehouse.id, "superb");
            } else {
                this.shippingForm.warehouses.splice(index, 1);
            }
        },
        addCustomerWarehouse() {
            this.shippingForm.customerWarehouses.push({
                id: null,
                warehouse_id: null,
                address: null,
            });
        },
        removeCustomerWarehouse(warehouse, index) {
            if (warehouse.id) {
                this.deleteWarehouse(warehouse.id, "customer");
            } else {
                this.shippingForm.customerWarehouses.splice(index, 1);
            }
        },
        addBillTo() {
            this.shippingForm.billTo.push({
                id: null,
                warehouse_id: null,
                address: null,
            });
        },
        removeBillTo(warehouse, index) {
            if (warehouse.id) {
                this.deleteWarehouse(warehouse.id, "customer", true);
            } else {
                this.shippingForm.billTo.splice(index, 1);
            }
        },
        getWarehouses(is_customer = 0) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            let url = window.route("getWarehouses");
            if (is_customer) {
                if (this.order.customer) {
                    url = window.route("getWarehouses", {
                        customer_id: this.order.customer.id,
                    });
                } else {
                    return;
                }
            }
            return axios
                .get(url, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        if (is_customer) {
                            this.customerWarehouses = data.data;
                            let defaultWarehouses =
                                this.customerWarehouses.filter(
                                    (x) => x.is_default
                                );
                            if (
                                defaultWarehouses.length &&
                                (this.shippingForm.customerWarehouses[0]
                                    .address == null ||
                                    this.shippingForm.customerWarehouses[0]
                                        .address == "") &&
                                this.shippingForm.customerWarehouses[0]
                                    .warehouse_id == null
                            ) {
                                this.shippingForm.customerWarehouses[0].warehouse_id =
                                    defaultWarehouses[0].id;
                            }
                        } else {
                            this.warehouses = data.data;
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        saveShippingData() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("so.updateOrderShippingData", {
                        id: this.order.id,
                    }),
                    this.shippingForm,
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.$emit("updatedShippingEvent");
                        //self.isEditMode = false;
                        /*self.customerForm = {
                            customer: null,
                            customer_id: null,
                        };*/
                        self.setSuccessMessage("Order saved successfully");
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        deleteWarehouse(id, type = "customer", isBill = false) {
            let self = this;
            Vue.$confirm({
                title: "Are you sure?",
                message: "Are you sure you want to delete?",
                button: {
                    yes: "Yes",
                    no: "Cancel",
                },
                callback: (confirm) => {
                    if (confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios
                            .delete(
                                window.route("orders.warehouses.destroy", {
                                    id: self.order.id,
                                    warehouse_id: id,
                                }),
                                {
                                    validateStatus: function (status) {
                                        return status < 500; // Resolve only if the status code is less than 500
                                    },
                                }
                            )
                            .then(({ data }) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.$emit("updatedShippingEvent");
                                    self.setSuccessMessage(
                                        "Warehouse deleted from order!"
                                    );
                                    if (type === "customer") {
                                        if (isBill) {
                                            self.order.products.splice(
                                                self.shippingForm.billTo.indexOf(
                                                    (x) => x.id == id
                                                ),
                                                1
                                            );
                                        } else {
                                            self.order.products.splice(
                                                self.shippingForm.customerWarehouses.indexOf(
                                                    (x) => x.id == id
                                                ),
                                                1
                                            );
                                        }
                                    } else {
                                        self.order.products.splice(
                                            self.shippingForm.warehouses.indexOf(
                                                (x) => x.id == id
                                            ),
                                            1
                                        );
                                    }
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(
                                    error.response &&
                                        error.response.errorMessage
                                        ? error.response.errorMessage
                                        : error.message
                                );
                            })
                            .finally(() => {
                                self.setLoading(false);
                            });
                    }
                },
            });
        },
        syncLatestData() {
            this.shippingForm.is_stocking = this.order.is_stocking;
            this.shippingForm.stocking_terms = this.order.stocking_terms;
            this.shippingForm.warehouses = _.cloneDeep(this.order.warehouses);
            this.shippingForm.customerWarehouses = _.cloneDeep(
                this.order.customer_warehouses
            );
            this.shippingForm.billTo = _.cloneDeep(this.order.bill_warehouses);

            if (
                this.order.customer_warehouses &&
                this.order.customer_warehouses.length == 0
            ) {
                this.shippingForm.customerWarehouses = [
                    {
                        id: null,
                        warehouse_id: null,
                        address: null,
                    },
                ];
            }

            if (
                this.order.bill_warehouses &&
                this.order.bill_warehouses.length == 0
            ) {
                this.shippingForm.billTo = [
                    {
                        id: null,
                        warehouse_id: null,
                        address: null,
                    },
                ];
            }
        },
    },
    computed: {
        ...mapState(["salesOrderState"]),
        ...mapGetters(["maxNumOfShipToAddress"]),
    },
    watch: {
        "shippingForm.is_stocking": {
            handler: function (after, before) {
                if (after == 1) {
                    this.shippingForm.warehouses = [
                        {
                            id: null,
                            warehouse_id: null,
                            address: null,
                        },
                    ];

                    if (this.warehouses.length) {
                        let defaultWarehouses = this.warehouses.filter(
                            (x) => x.is_default
                        );
                        if (defaultWarehouses.length) {
                            this.shippingForm.warehouses[0].warehouse_id =
                                defaultWarehouses[0].id;
                        }
                    }
                } else {
                    this.shippingForm.warehouses = [];
                }
            },
        },
        order: {
            handler: function (after, before) {
                this.syncLatestData();
            },
        },
    },
};
</script>

<style scoped></style>
